var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWishlist = function SvgWishlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v34h25.666V0H0Zm24.57 32.865H1.097V1.095H24.57v31.77ZM7.083 12.168c-.744-1.213-.9-2.27-.861-3.013.039-.782.352-1.526.939-2.034.548-.47 1.487-.94 2.817-.665 2.504.547 2.856 2.66 2.856 2.66s.43-2.113 2.856-2.66c1.33-.274 2.23.156 2.817.665.587.508.94 1.252.94 2.034.038.744-.118 1.76-.861 3.013-1.33 2.27-5.204 5.125-5.713 5.517 0 0-4.42-3.248-5.79-5.517Zm13.694 10.407H4.89V21.48h15.885v1.095Zm0 2.505H4.89v-1.096h15.885v1.096Zm0 2.504H4.89v-1.096h15.885v1.096Z",
    fill: "currentcolor"
  })));
};
export default SvgWishlist;